<template>
    <div class="map-container" @click.prevent.stop>
        <google-map
            id="map"
            ref="Map"
            :center="position | convertLatLng"
            :zoom="location ? 10 : 5"
            :options="{
                fullscreenControl: false,
                scaleControl: true,
                mapTypeControl: true,
                mapTypeControlOptions: {
                    position: 3,
                },
                minZoom: 2,
            }"
            @click="moveMarker"
        >
            <google-map-autocomplete
                :slot="'before'"
                :update-map="true"
                :controls="false"
                :placeholder="$t('Object.mapSearch')"
                @place-changed="searchResult"
            />
            <google-map-marker
                v-if="location"
                :position="location | convertLatLng"
                :draggable="true"
                :icon="'/img/icons/poi.png'"
                @dragend="moveMarker"
            />
            <google-map-marker
                v-for="object in locations"
                :key="object._id"
                :title="object.title"
                :position="object.location | convertLatLng"
                :draggable="false"
                :icon="'/img/icons/poides.png'"
            />
        </google-map>
        <p v-if="location" class="has-text-grey">
            {{ location.latitude }},{{ location.longitude }}
        </p>
    </div>
</template>

<script>
import _ from 'underscore';
import MapboxToGoogleMaps from '@/mixins/MapboxToGoogleMaps';
export default {
    mixins: [MapboxToGoogleMaps],
    model: {
        prop: 'location',
    },
    props: {
        location: {
            type: Object,
            default() {
                return this.IPLocation;
            },
        },
        locations: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    data() {
        return {
            position: this.location || { latitude: 40, longitude: -2 },
            zoomLevel: this.location ? this.location.zoomLevel || 4 : 14,
        };
    },
    computed: {
        IPLocation() {
            return this.$store.getters.IPLocation;
        },
    },
    methods: {
        moveMarker({ latLng }) {
            this.setPosition(latLng.lng(), latLng.lat());
        },
        searchResult(ev) {
            const { location } = ev.geometry;
            this.setPosition(location.lng(), location.lat());
        },
        setPosition(lon, lat) {
            // this.$set(this.position, 'latitude', lat);
            // this.$set(this.position, 'longitude', lon);
            this.$emit('input', { latitude: lat, longitude: lon });
        },
    },
};
</script>

<style scoped>
@import '~vuejs-google-maps/dist/vuejs-google-maps.css';
.map-container {
    height: 80%;
}
/deep/.pac-card {
    left: 10px;
    right: inherit;
    color: black;
    width: 30%;
}
/deep/.pac-card .pac-input-container {
    width: 100%;
}
</style>
